import { REDUCER_KEY_INVITES } from "./invites.reducer";
export var invites = function (state) { return state.invites.invites; };
export var isFetching = function (state) { return state.invites.isFetching; };
export var fetchError = function (state) { return state.invites.fetchError; };
export var pendingInvites = function (state) {
    return state.invites.pendingInvites;
};
